import React from 'react';
import { StanCard } from '@/components';
import { useModal } from '@/hooks/useModal';
import { TwoFactorAuthSection } from './security/TwoFactorAuthSection';
import { LoginSessionsSection } from './security/LoginSessionsSection';
import { AccountDeletionSection } from './security/AccountDeletionSection';
import { ConfigureMFAModal } from './security/modals/ConfigureMFAModal';
import { useExperiments } from '@/features/Experiments/hooks';
import { EXPERIMENTS } from '@/features/Experiments/constants';
import { useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/lib/constants';

export const SecurityTab: React.FC = () => {
    const { hasExperiment } = useExperiments();
    const queryClient = useQueryClient();
    const configureMFAModal = useModal();

    const handleConfigureMFA = () => {
        configureMFAModal.open();
    };

    const handleMFASetupComplete = () => {
        // Invalidate login sessions to refresh after MFA setup
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.LOGIN_SESSIONS] });
    };

    return (
        <StanCard>
            <div className='space-y-8'>
                {/* Two-Factor Authentication Section */}
                <TwoFactorAuthSection onConfigureMFA={handleConfigureMFA} onMFASetupComplete={handleMFASetupComplete} />

                <LoginSessionsSection />

                {/* Account Deletion Section - Only show when experiment is enabled */}
                {hasExperiment(EXPERIMENTS.ACCOUNT_DELETION_V082025) && (
                    <div className='max-w-3xl'>
                        <AccountDeletionSection />
                    </div>
                )}
            </div>

            <ConfigureMFAModal
                isOpen={configureMFAModal.isOpen}
                onClose={configureMFAModal.close}
                onSuccess={handleMFASetupComplete}
                source='toggle'
            />
        </StanCard>
    );
};

export default SecurityTab;
